import { region, sanityDataset } from 'utils/environment';

const SANITY_FILES_CDN_URL = 'https://cdn.sanity.io/files';

export const buildFileUrl = (source: string, sanityProjectId?: string) => {
  if (!sanityProjectId || !source?.startsWith('file-')) {
    return '';
  }

  const dataset = region
    ? `${sanityDataset()}_${region.toLowerCase()}`
    : sanityDataset().toLowerCase();

  // source: file-<hash>-<ext>
  const [, id, ext] = source.split('-');
  if (!id || !ext) {
    return '';
  }

  return `${SANITY_FILES_CDN_URL}/${sanityProjectId}/${dataset}/${id}.${ext}`;
};
